/* PMP — Page Offres Q4 (01/11/2026) : onglets, ajout au panier, remise lue dans le panier. */
(function(){
  var root=document.querySelector('[data-pmo]');if(!root)return;
  var S=JSON.parse(root.querySelector('[data-pmo-strings]').textContent);
  var tabs=[].slice.call(root.querySelectorAll('[data-pmo-tab]'));
  var panels=[].slice.call(root.querySelectorAll('[data-pmo-panel]'));
  var bar=document.querySelector('[data-pmo-bar]');
  var msg=bar.querySelector('[data-pmo-msg]'),cnt=bar.querySelector('[data-pmo-count]');
  var cur=panels[0],lastCart=null;
  function ids(p){var a=[];
    p.querySelectorAll('option').forEach(function(o){a.push(o.value)});
    p.querySelectorAll('[data-pmo-add]').forEach(function(b){a.push(b.getAttribute('data-id'))});
    p.querySelectorAll('[data-pmo-ids]').forEach(function(b){a.push(b.getAttribute('data-pmo-ids'))});
    return a;}
  function money(c,ccy){try{return new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:ccy}).format(c/100)}catch(e){return (c/100).toFixed(2)+' '+ccy}}
  function paint(){var c=lastCart;if(!c||!cur)return;
    cnt.textContent=c.item_count?S.items.replace('[n]',c.item_count):S.empty;
    var list=ids(cur),n=0,save=0,off=cur.getAttribute('data-offer');
    c.items.forEach(function(i){
      if(list.indexOf(String(i.variant_id))>-1)n+=i.quantity;
      (i.line_level_discount_allocations||[]).forEach(function(a){var t=(a.discount_application&&a.discount_application.title)||'';if(t.indexOf(off)===0)save+=a.amount;});
    });
    (c.cart_level_discount_applications||[]).forEach(function(d){if((d.title||'').indexOf(off)===0)save+=(d.total_allocated_amount||0);});
    var need=+cur.getAttribute('data-need')||0,t,ok=false;
    if(save>0){t=S.ok.replace('[x]',money(save,c.currency));ok=true;}
    else if(need&&n<need){t=S.need.replace('[n]',need-n);}
    else if(c.total_discount>0){t=S.other;}
    else{t=cur.getAttribute('data-hint')||S.need.replace('[n]',1);}
    msg.textContent=t;msg.classList.toggle('is-ok',ok);}
  function refresh(){
    return fetch(root.getAttribute('data-cart')+'.js',{headers:{Accept:'application/json'},cache:'no-store'})
      .then(function(r){return r.json()})
      .then(function(c){lastCart=c;paint();
        document.querySelectorAll('[data-cart-count],.js-cart-count,.cart-count,.header__cart-count').forEach(function(e){e.textContent=c.item_count;});})
      .catch(function(){});}
  function show(id){
    var p=panels.filter(function(x){return x.getAttribute('data-id')===id})[0]||panels[0];cur=p;
    panels.forEach(function(x){x.hidden=(x!==p)});
    tabs.forEach(function(t){var on=t.getAttribute('data-id')===p.getAttribute('data-id');t.classList.toggle('is-on',on);t.setAttribute('aria-selected',on?'true':'false');if(on&&t.parentNode)t.parentNode.scrollLeft=Math.max(0,t.offsetLeft-24);});
    paint();}
  tabs.forEach(function(t){t.addEventListener('click',function(){var id=t.getAttribute('data-id');try{history.replaceState(null,'','#'+id)}catch(e){}show(id);});});
  window.addEventListener('hashchange',function(){show(location.hash.slice(1))});
  root.addEventListener('change',function(e){
    var s=e.target.closest('[data-pmo-sel]');if(!s)return;
    var o=s.options[s.selectedIndex],tile=s.closest('[data-pmo-tile]');
    var b=tile.querySelector('[data-pmo-add]');if(b){b.setAttribute('data-id',s.value);b.disabled=o.disabled;}
    var im=tile.querySelector('[data-pmo-img]');if(im&&o.getAttribute('data-img'))im.src=o.getAttribute('data-img');
    var pr=tile.querySelector('[data-pmo-now]');if(pr)pr.textContent=o.getAttribute('data-p');});
  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-pmo-add]');if(!b||b.disabled)return;
    var label=b.getAttribute('data-label')||b.textContent;b.setAttribute('data-label',label);b.disabled=true;
    fetch(root.getAttribute('data-add')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+b.getAttribute('data-id'),quantity:1}]})})
      .then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(){b.textContent=S.added;b.classList.add('is-ok');try{document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh',{bubbles:true}))}catch(x){}return refresh();})
      .catch(function(){b.textContent=S.err;})
      .then(function(){setTimeout(function(){b.textContent=label;b.classList.remove('is-ok');b.disabled=false;},2200);});});
  show(location.hash.slice(1));refresh();
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh();});
})();
